import { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';

import { RadioButton, RadioButtonProperties } from './radio-button';
import { Input } from '../input/input';
import { InputProps } from '../input/input.types';

const input1Classes = '';
const input2Classes = 'px-2';
const containerClasses = '';

export interface RadioInputProps extends RadioButtonProperties {
  /** Whether the radio input is checked */
  checked: boolean;
  input1Text?: string;
  input1Props: Partial<InputProps>;
  input2Text?: string;
  input2Props?: Partial<InputProps>;
  onValueChange: (radioValue: string, inputValues: string[]) => void;
}

// eslint-disable-next-line max-lines-per-function
export const RadioInput = (props: RadioInputProps) => {
  const { input1Text, input1Props, input2Text, input2Props, checked, onValueChange, ...rest } = props;
  const ref = useRef<HTMLInputElement>();
  const [radioChecked, setRadioChecked] = useState<boolean>(checked);
  const [input1, setInput1] = useState((input1Props.value ?? '').toString());
  const [input2, setInput2] = useState((input2Props?.value ?? '').toString());

  useEffect(() => setRadioChecked(checked), [checked]);
  useEffect(() => setInput1((input1Props.value ?? '').toString()), [input1Props.value]);
  useEffect(() => setInput2((input2Props?.value ?? '').toString()), [input2Props?.value]);

  const radioOnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      console.log(e.target.value);
      onValueChange(e.target.value, [input1, input2]);
    },
    [input1, input2, onValueChange]
  );

  const input1OnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setInput1(e.target.value);
      onValueChange((ref.current as HTMLInputElement).value, [e.target.value, input2]);
    },
    [input2, onValueChange]
  );

  const input2OnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setInput2(e.target.value);
      onValueChange((ref.current as HTMLInputElement).value, [input1, e.target.value]);
    },
    [input1, onValueChange]
  );

  return (
    <RadioButton
      ref={(thisInput) => (ref.current = thisInput as HTMLInputElement)}
      {...rest}
      onChange={radioOnChange}
      checked={checked}
    >
      <div className={containerClasses}>
        {radioChecked ? (
          <div className="flex items-center">
            {input1Text ? <div className={input1Classes}>{input1Text}</div> : undefined}
            <div className="w-24">
              <Input className="py-1" {...input1Props} value={input1} prefix="" onChange={input1OnChange} />
            </div>
            {input2Text ? <div className={input2Classes}>{input2Text}</div> : undefined}
            {input2Props ? (
              <div className="w-24">
                <Input className="py-1" {...input2Props} value={input2} onChange={input2OnChange} prefix="" />
              </div>
            ) : undefined}
          </div>
        ) : undefined}
      </div>
    </RadioButton>
  );
};

export default RadioInput;
